module.exports = __webpack_public_path__ + "media/30th_anniversary_sweepstakes/member-green-4f70a065.svg";